export const TEST_ID = 'sourceBadge';

export const JD_TAG_PREFIX = '(JD-';
